export default {
  init($element) {

  },
  finalize($element) {
    const $ctaLink = $element.find('.cta-link-primary');
    if ($ctaLink.data('switch-type')) {
      $ctaLink.on('click', function(e) {
        e.preventDefault();
        e.stopPropagation();

        const newType = $ctaLink.data('new-type');

        const date = new Date();
        date.setTime(date.getTime() + (30 * 24 * 60 * 60 * 1000));

        const expiresTime = date.toUTCString();

        document.cookie = `visitor_pref=${newType}; expires=${expiresTime}; path=/`;

        const url = $ctaLink.attr('href');
        window.location.replace(url);
      });
    }
  },
}


// WEBPACK FOOTER //
// ./scripts/partials/shared/largeCallToAction.js